import {Vue, Component} from 'vue-property-decorator';
import Navigation from '@/components/Navigation';
import DisableAccess from '@/components/DisableAccess';
import Icon from '@/components/Icon';

import GlobalStore from '@/store/GlobalStore';

@Component
export default class  extends Vue {
  
  state = {
    GlobalStore
  }
  
  async mounted () {
  
  }
  
  render() {
    console.log(this.$route.query);
    const text: string = this.$route.query.stop ? (window.localStorage.getItem('disableText') || '') : this.state.GlobalStore.disableText
    return (
      <div class='card'>
        <Navigation left={<Icon />}  title='爱云兔云手机'  />
        <DisableAccess description={text} />
      </div>
    )
  }
  
}